module.exports = {
      id: "premium-usage",
      viewBox: "0 0 576 512",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#premium",
      toString: function () {
        return this.url;
      }
    }